import React from 'react';
import { Create, SimpleForm } from 'react-admin';
import AssetUploadButton from './assetUpload.component';
import { Box, Typography } from '@mui/material';

const AssetCreate = () => {
  return (
    <Create>
      <SimpleForm toolbar={false}>
        <Box sx={{ p: 2 }}>
          <Typography variant="h6" gutterBottom>
            Upload Marketing Asset
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Use the button below to upload a new marketing asset. Supported formats: PDF, PNG, JPG, GIF, WebP.
          </Typography>
          <AssetUploadButton />
        </Box>
      </SimpleForm>
    </Create>
  );
};

export default AssetCreate;
